import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    OrganizationPathParamsSchema,
    OrganizationServiceCreateSchema,
    OrganizationServiceUpdateSchema,
    ServicePathParamsSchema,
} from "../schemas/organization-service.schema";
import { OrganizationServiceSchema } from "../types/organizationService";

export { OrganizationServiceCreateSchema, OrganizationServiceUpdateSchema };
export type {
    OrganizationServiceCreate,
    OrganizationServiceUpdate,
} from "../schemas/organization-service.schema";

const c = initContract();

export const organizationServiceContract = c.router(
    {
        listOrganizationServices: {
            method: "GET",
            path: "/organizations/:organizationId",
            pathParams: OrganizationPathParamsSchema,
            responses: {
                200: z.object({
                    services: z.array(OrganizationServiceSchema),
                }),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        createOrganizationService: {
            method: "POST",
            path: "/organizations/:organizationId",
            pathParams: OrganizationPathParamsSchema,
            body: OrganizationServiceCreateSchema,
            responses: {
                201: OrganizationServiceSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        updateOrganizationService: {
            method: "PATCH",
            path: "/organizations/:organizationId/:serviceId",
            pathParams: OrganizationPathParamsSchema.merge(
                ServicePathParamsSchema,
            ),
            body: OrganizationServiceUpdateSchema,
            responses: {
                200: OrganizationServiceSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteOrganizationService: {
            method: "DELETE",
            path: "/organizations/:organizationId/:serviceId",
            pathParams: OrganizationPathParamsSchema.merge(
                ServicePathParamsSchema,
            ),
            responses: {
                200: c.noBody(),
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-services",
    },
);
